/**
 * Checks if the provided value is a valid integer.
 *
 * @param value - The value to check, which can be a number or undefined.
 * @returns `true` if the value is a non-null integer, otherwise `false`.
 */
export const isInteger = <T extends number | undefined>(value: T) =>
  value != null && Number.isInteger(value);

/* Clamp
 *
 * Restricts a number to be within a specified range.
 *
 * @param n - The number to clamp.
 * @param min - The lower bound of the range.
 * @param max - The upper bound of the range.
 * @returns The clamped value, which will be between `min` and `max`.
 */
export const clamp = (n: number, min: number, max: number) => Math.max(min, Math.min(max, n));
